import { render, staticRenderFns } from "./ParticipantDetailModal.vue?vue&type=template&id=79df177a&"
import script from "./ParticipantDetailModal.vue?vue&type=script&lang=js&"
export * from "./ParticipantDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports